import FilesService from "@/services/files.service";

export const move = {
    namespaced: true,   
    state: {
        action:"",
        moveArray: [],

        progress: {
            total: 0,
            completed: 0
        }
    },
    getters: {
        moveCopyProgress(state) {
            const { total, completed } = state.progress;

            if (total === 0)
                return 0;

            return Math.round((completed / total) * 100);
        }
    },
    actions: {
        async pasteFiles({ dispatch, commit, state }, targetDir) {
            const { oldDir, files } = state.moveArray;

            if (oldDir === targetDir)
                return;

            const isMove = state.action === "move";
            const service = isMove
                    ? FilesService.moveFile
                    : FilesService.copyFile;

            let targets = [];
            const foldersToDelete = [];  // 여기

            for (const item of files) {
                if (item.isFile) {
                    targets.push({ folder: "", file: item });
                } else {
                    // 이동 후 삭제할 원본 폴더 저장
                    foldersToDelete.push(item);
                    const result = await FilesService.getAllFilesInFolder(oldDir, item);
                    targets.push(...result.files);
                }
            }

            commit("setProgress", {
                total: targets.length,
                completed: 0
            });

            for (const target of targets) {
                const file = await service(
                        oldDir,
                        targetDir,
                        target.folder,
                        target.file
                    );

                dispatch("files/setFile", file, { root: true });

                commit("increaseCompleted");
            }            
            if (isMove && foldersToDelete.length) {
                for (const folder of foldersToDelete) {
                    try {
                        await FilesService.postFileRecycle(
                            [folder],
                            oldDir,
                            true
                        );
                    } catch (err) {
                        console.warn("폴더 삭제 실패", folder.name, err);
                    }
                }
            }

            await dispatch("files/setSortFiles", null, { root: true });

            dispatch("setCleanMoveArray");
            dispatch("setChangeAction");

            setTimeout(() => {
                commit("clearProgress");
            }, 1000);
        },
        preparePaste({ commit, rootState, rootGetters }, action) {
            commit("addMoveArray", {
                oldDir: rootGetters["files/currentDirPath"],
                files: [...rootState.files.selectArray]
            });

            commit("changeAction", action);
        },
        setAddMoveArray({ commit }, file) {
            commit('addMoveArray', file)
        },
        setChangeAction({ commit }, cmd) {
            commit('changeAction', cmd)
        },
        setCleanMoveArray({ commit }) {
            commit('cleanMoveArray')
        },
    },
    mutations: {
        addMoveArray(state, file) {
            state.moveArray = file;
        },
        cleanMoveArray(state) {
            state.moveArray.length = 0;
        },
        changeAction(state, cmd) {
            state.action = cmd;
        },
        setProgress(state, progress) {
            state.progress = progress;
        },
        increaseCompleted(state) {
            state.progress.completed++;
        },
        clearProgress(state) {
            state.progress = {
                total: 0,
                completed: 0
            };
        }
    }
};